import { DnsRecordResults } from '../../app/modules/types/dnsRecord'
import { apiClient } from '../client'

/**
 * DNS API endpoints
 */
export const dnsApi = {
  /**
   * Get DNS records list
   */
  getList: async (params?: string): Promise<DnsRecordResults> => {
    const url = params ? `/dns-record/?${params}` : '/dns-record/'
    const { data } = await apiClient.get(url)
    return data
  },

  /**
   * Get DNS record by ID
   */
  getById: async (dnsId: string): Promise<any> => {
    const { data } = await apiClient.get(`/dns-record/${dnsId}/`)
    return data
  },

  /**
   * Get DNS statistics
   */
  getStats: async (): Promise<any> => {
    const { data } = await apiClient.get('/dns-record/stats/')
    return data
  },

  /**
   * Get DNS filter options
   */
  getFilterOptions: async (): Promise<any> => {
    const { data } = await apiClient.get('/dns-record/filter/')
    return data
  },
}
